/**
 * Event
 * Create a single event entity
 *
 * @todo Background colour is dependant on .section__events .event__wrapper--row-wrapper .event__row - probably should not be.
 * @todo link is empty so assume I would use the slug to navigate to the events template, but there is no events template?
 * @todo This is quite nasty - really should have Grid components
 * @todo Check that end date exists - getting Invalid time on some contentful
 */
import React, { ComponentType } from 'react'

// eslint-disable-next-line import/prefer-default-export
import { FormatStartDate, formatTime, Header } from '../..'
import { Image } from '../../Image/Image'
import { formatTimeWithZone } from '../../utils'

const HTTPS = 'https://'
const renderLinkDefault = ({ children, vanityUrl }: EventRenderLinkProps) =>
  vanityUrl && vanityUrl.includes(HTTPS) ? (
    <a href={vanityUrl} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ) : (
    <a href={HTTPS + vanityUrl} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  )

export type EventRenderLinkProps = Partial<EventProps>

export type EventImage = {
  fixed: {
    src: string
  }
  title: string
}

export type EventSecReg = {
  slug: string
  title: string
}

export type EventProps = {
  children?: any
  endDate?: string
  eventType?: string
  image: EventImage
  locationAddress: string
  locationCity: string
  locationCountry: string
  locationName: string
  regions: EventSecReg[]
  sectors: EventSecReg[]
  countries: EventSecReg[]
  renderLink?: ComponentType<EventRenderLinkProps>
  renderImage?: ComponentType<EventRenderImageProps>
  vanityUrl: string
  startDate: string
  timeZone?: string
  title: string
  isWebinar?: boolean
}

export type EventRenderImageProps = Partial<EventImage>

const renderImageDefault = ({
  fixed = { src: '' },
  title = ''
}: EventRenderImageProps) => <Image src={fixed && fixed.src} alt={title} />

export const EventListing = (props: EventProps) => {
  const {
    eventType,
    endDate,
    image,
    renderLink: Link = renderLinkDefault,
    renderImage: Img = renderImageDefault,
    startDate,
    timeZone,
    title
  } = props

  const isMultiDays = (startDate: string, endDate: string) => {
    const startTime = new Date(startDate).getTime() / 1000
    const endTime = new Date(endDate).getTime() / 1000
    return endTime - startTime >= 86400
  }
  const eventEndDate = endDate || ''

  return (
    <div className="event__row column__three column--merge-a">
      <div className="column column--1">
        <div className="event__date">
          <div className="heading--6">
            {isMultiDays(startDate, eventEndDate) ? (
              <>
                {FormatStartDate(startDate)} -{' '}
                <div>{FormatStartDate(eventEndDate)}</div>
              </>
            ) : (
              FormatStartDate(startDate)
            )}
          </div>
          <p>
            {startDate && formatTime(startDate)}
            {endDate && ` - ${formatTimeWithZone(endDate, timeZone)}`}
          </p>
        </div>
      </div>

      <div className="column column--2">
        <div className="image-wrapper">
          <Link {...props}>
            <Img {...image} />
          </Link>
        </div>
      </div>

      <div className="column column--3">
        <Header level={3} className="event__title">
          <Link {...props}>{title}</Link>
        </Header>

        <p className="event__location">{eventType}</p>
      </div>
    </div>
  )
}
export default EventListing
